import { ProductKey, ProductsType, ProductsTypeBack } from 'src/constants/products';
import { COSSUPORT_DEMO_PAGE } from 'src/shared/constants';
import { CreateNewAgentCard } from 'src/components/HomePageComponents/CreateNewAgent/CreateNewAgentCard';
import { useAppSelector } from 'src/store';
import { API_VERSION } from 'src/constants/api-routes';
import { getApiVersion } from 'src/utils/apiVersion';
import { useIsCosupportManager } from 'src/hooks/useIsCosupportManager';
import { GeneralPlan, useGetAccountsQuery } from 'src/services/accountsService';
import { Project, useGetAllProjectsQuery } from 'src/services';

// Whether the plan's project limit is reached for a product; no plan means no limit.
const isProjectsLimitReached = (
  type: ProductKey,
  projects: Project[] = [],
  generalPlan?: GeneralPlan,
) => {
  if (!generalPlan) return false;
  const maxProjects = generalPlan[`max_projects_${ProductsTypeBack[type]}`] as number;
  const projectsCount = projects.filter((project) => project.project_type === type).length;
  return projectsCount >= maxProjects;
};

export const CreateNewAgentContent = (_props?: { close?: () => void }) => {
  const { data: projects } = useGetAllProjectsQuery();
  const { data: account } = useGetAccountsQuery();
  const isCosupportManager = useIsCosupportManager();
  const { isInactivePlan } = useAppSelector((s) => s.planSlice);
  const version = getApiVersion();
  const isV2 = version === API_VERSION.V2;
  const isLimitReached = (type: ProductKey) =>
    isProjectsLimitReached(type, projects, account?.general_plan);

  return (
    <div>
      <p className="pb-2.5 font-medium opacity-50 text-sm font-jamjuree">Select a product</p>
      <div className="flex gap-2.5">
        <CreateNewAgentCard
          type={ProductsType.agent}
          isAdmin={isCosupportManager}
          navigationLink={COSSUPORT_DEMO_PAGE}
          disabled={isInactivePlan || isV2 || isLimitReached(ProductsType.agent)}
        />
        <CreateNewAgentCard
          type={ProductsType.customer}
          disabled={isInactivePlan || isLimitReached(ProductsType.customer)}
        />
        <CreateNewAgentCard
          disabled={isInactivePlan || isV2 || isLimitReached(ProductsType.bi)}
          type={ProductsType.bi}
          isAdmin={isCosupportManager}
          navigationLink={COSSUPORT_DEMO_PAGE}
        />
      </div>
    </div>
  );
};
